var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
export function sortAlphabetically(keys) {
    return __spreadArray([], keys).sort(function (a, b) {
        if (a.toLocaleLowerCase() < b.toLocaleLowerCase())
            return -1;
        if (a.toLocaleLowerCase() > b.toLocaleLowerCase())
            return 1;
        return 0;
    });
}
//# sourceMappingURL=sortAlphabetically.js.map